import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ModalFormHostService } from './modal-form-host.service';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [ModalFormHostService]
})
export class ModalFormHostServiceModule {}
